import { render, staticRenderFns } from "./TheUser.vue?vue&type=template&id=9785f6a0&"
import script from "./TheUser.vue?vue&type=script&lang=js&"
export * from "./TheUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports